import React from 'react';
import moment from 'moment';
import DatePicker from 'react-bootstrap-date-picker';
import TimePicker from 'react-bootstrap-time-picker';
import Select from 'react-select';
import { postEntity } from 'src/utils/entityApi';
import data_criticity from 'src/data/criticity';
import InputFormAssociated from '../input/inputFormAssociated';
import withAuth from 'src/hoc/withAuth';

const apiEmployeeShow = '/api/employee/';
const apiAppointmentType = '/api/appointment/getAppointmentTypes/';

const oriState = {
  dataEmployee: undefined,
  employeeSelected: '',
  title: undefined,
  text: undefined,
  criticity: -1,
  dateMeeting: undefined,
  timeMeeting: 12 * 3600,
  place: undefined,
  duration: 0,
  employeesConcerned: [],
  appointmentType: undefined,
  appointmentTypes: undefined,
};

class ModalAppointmentPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.close = this.close.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }
  handleDateChange(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      dateMeeting: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }
  handleTimeChange(timeMeeting) {
    this.setState({ timeMeeting });
  }
  handleInputSelectChange(val) {
    console.log(val);

    //let tab = this.state.employeesConcerned;

    this.setState({
      employeeSelected: val,
      employeesConcerned: val,
    });
  }

  componentDidMount() {
    let queryURL = apiEmployeeShow;
    let graphQL = '{ employees{ id, firstname, lastname } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['employees']) {
            this.setState({
              dataEmployee: data['data']['employees'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch list employees entity: \n' + error);
        }.bind(this)
      );

    this.getAppointmentTypes();
  }

  checkFormValid() {
    return (
      this.state.title &&
      this.state.criticity &&
      this.state.criticity !== -1 &&
      this.state.dateMeeting &&
      this.state.timeMeeting &&
      this.state.duration &&
      this.state.duration !== 0 &&
      this.state.employeesConcerned &&
      this.state.employeesConcerned.length !== 0
    );
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { dataEmployee } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Créer Rendez-vous</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                <div className='form-group'>
                  <label>Titre</label>
                  <input
                    name='title'
                    value={this.state.title}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Retrouver le rdv plus tard'
                  />
                </div>
                <div className='form-group'>
                  <label>Texte</label>
                  <textarea
                    name='text'
                    value={this.state.text}
                    onChange={this.handleInputChange}
                    className='form-control'
                    placeholder='Description du rdv (facultatif)'
                  />
                </div>
                <div className='form-group'>
                  <label>Type de RDV</label>
                  <select
                    name='appointmentType'
                    value={this.state.appointmentType ? this.state.appointmentType : 'none'}
                    onChange={this.handleInputChange}
                    className='form-control'
                  >
                    <option disabled value='none' />
                    {this.state.appointmentTypes ? (
                      Object.entries(this.state.appointmentTypes).map(([key, data]) => (
                        <option key={key} value={data.id}>
                          {data.name}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                </div>
                <div className='form-group'>
                  <label>Criticité</label>
                  <select
                    name='criticity'
                    value={this.state.criticity}
                    onChange={this.handleInputChange}
                    className='form-control'
                  >
                    <option value={-1}>Sélectionner criticité</option>
                    {data_criticity ? (
                      Object.entries(data_criticity).map(([key, data]) => (
                        <option key={key} value={key}>
                          {key + '-' + data.fr}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                </div>
                <div className='form-group'>
                  <label>Lieu</label>
                  <input
                    name='place'
                    value={this.state.place}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Lieu du rdv (facultatif)'
                  />
                </div>
                <div className='form-group'>
                  <label>Date</label>
                  <DatePicker
                    calendarContainer={this}
                    name='dateMeeting'
                    defaultValue={moment().format('YYYY-MM-DD')}
                    value={this.state.dateMeeting}
                    onChange={this.handleDateChange}
                    dateFormat='YYYY-MM-DD'
                  />
                </div>
                <div className='form-group'>
                  <label>Heure</label>
                  <TimePicker
                    format={24}
                    initialValue={'12:00'}
                    onChange={this.handleTimeChange}
                    value={this.state.timeMeeting}
                  />
                </div>
                <div className='form-group'>
                  <label>Durée prévue (en min)</label>
                  <input
                    min='0'
                    step='5'
                    name='duration'
                    value={this.state.duration}
                    onChange={this.handleInputChange}
                    type='number'
                    className='form-control'
                  />
                </div>
                <div className='form-group'>
                  <label>Employés associés</label>
                  <Select
                    multi={true}
                    className='inputModalSelect'
                    name='employeeSelected'
                    value={this.state.employeeSelected}
                    labelKey={'firstname'}
                    valueKey={'id'}
                    options={dataEmployee}
                    onChange={this.handleInputSelectChange}
                    noResultsText={'Aucun résultat'}
                    placeholder={'Nom'}
                    clearValueText={'Supprimer'}
                  />
                </div>
                {this.props.entityAssociated && <InputFormAssociated entityAssociated={this.props.entityAssociated} />}
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Créer</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormValid()) {
        let json = {
          appointment: {
            title: this.state.title,
            text: this.state.text ? this.state.text : '',
            criticity: this.state.criticity,
            appointmentType: this.state.appointmentType,
            dateMeeting: moment(this.state.dateMeeting).seconds(this.state.timeMeeting).format('YYYY-MM-DD HH:mm'),
            place: this.state.place ? this.state.place : 'Non-renseigné',
            duration: this.state.duration,
          },
        };
        // If present -> set the Major Entity associated
        if (this.props.entityAssociated) {
          json.appointment['relativeTo'] = {
            [this.props.entityAssociated.type]: {
              id: this.props.entityAssociated.id,
            },
          };
        }
        // If present -> add the employees associated
        if (this.state.employeesConcerned && this.state.employeesConcerned.length > 0) {
          json.appointment['employeesConcerned'] = this.state.employeesConcerned;
        }

        this.props.onPostResult('appointment', postEntity(this.props.authFetch, 'appointment', json));
        this.close();
      } else {
        this.props.openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  }

  getAppointmentTypes = () => {
    this.props
      .authFetch(apiAppointmentType, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        this.setState({ appointmentTypes: data['data']['appointmentTypes'] });
      })
      .catch(() => {
        console.log('erreur fetch appointment types');
      });
  };

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalAppointmentPost);
